module.exports = __webpack_public_path__ + "static/media/ReviewImage1.35da6c96.png";